module.exports = __webpack_public_path__ + "img/products-2.3ccdf1c7.svg";